import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from 'src/app/global/global.module';
import { PlanejamentoSemanaCaptacaoMainComponent } from './planejamento-semana-captacao-main/planejamento-semana-captacao-main.component';

@NgModule({
  declarations: [PlanejamentoSemanaCaptacaoMainComponent],
  imports: [CommonModule, GlobalModule],
})
export class PlanejamentoSemanaCaptacaoModule {}
